<template>
  <div class="about">
      <v-container>
          <v-layout
                  wrap
          >
              <v-flex xs12 md8 offset-md2 :pa-5="!$vuetify.breakpoint.smAndDown" :pa-2="$vuetify.breakpoint.smAndDown" class="elevation-1">
                  <h1 class="text-xs-center mb-3">Ihr Kontakt zu uns</h1>
                  <v-form v-model="valid" ref="form">
                      <h2>Ihre Daten</h2>
                      <v-layout row>
                          <v-flex :md3="!$store.state.mobileOption" :md4="$store.state.mobileOption" :pa-2="!$vuetify.breakpoint.smAndDown">
                                <v-select box v-model="salutation" label="Anrede" :items="['Herr', 'Frau']" :rules="[rules.required]" required></v-select>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                          <v-flex :md3="!$store.state.mobileOption" :md4="$store.state.mobileOption" :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="firstname" label="Vorname" :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                          <v-flex :md3="!$store.state.mobileOption" :md4="$store.state.mobileOption" :pa-2="!$vuetify.breakpoint.smAndDown">
                                <v-text-field box v-model="lastname" label="Nachname" :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                          <v-flex :md3="!$store.state.mobileOption" :md4="$store.state.mobileOption" :pa-2="!$vuetify.breakpoint.smAndDown">
                                <v-text-field box v-model="email" label="Email" :rules="[rules.required, rules.email]" required validate-on-blur></v-text-field>
                          </v-flex>
                          <v-flex md3 v-if="!$store.state.mobileOption" :pa-2="!$vuetify.breakpoint.smAndDown">
                                <v-text-field box v-model="phone" label="Telefon" :rules="[rules.required, rules.phone]" required></v-text-field>
                          </v-flex>
                      </v-layout>
                      <v-layout v-if="$store.state.mobileOption" row wrap>
                          <v-flex md3 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="phone" label="Telefon" :rules="[rules.required, rules.phone]" required></v-text-field>
                          </v-flex>
                          <v-flex md3 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-select box return-object v-model="state" label="Staatsangehörigkeit" :items="states" @change="() => this.state = $event.target.value" required></v-select>
                          </v-flex>
                          <v-flex md3 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="idNumber" label="Ausweisnummer" :rules="[rules.required, rules.idNumber]" validate-on-blur></v-text-field>
                          </v-flex>
                          <v-flex md3 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="expiry" label="Gültig bis" :rules="[rules.required]"></v-text-field>
                          </v-flex>
                      </v-layout>

                      <h2>Ihre Adresse</h2>
                      <v-layout row wrap>
                          <v-flex md3 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="street" label="Straße" :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                          <v-flex md1 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="streetnr" label="Nr." :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                          <v-flex md4 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="zip" label="Postleitzahl" :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                          <v-flex md4 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="city" label="Stadt" :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                      </v-layout>

                      <h2>Ihre Kontodaten</h2>
                      <v-layout row wrap>
                          <v-flex md4 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="iban" label="IBAN" :rules="[rules.required, rules.IBAN]" required validate-on-blur></v-text-field>
                          </v-flex>
                          <v-flex md4 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-text-field box v-model="bank" label="Kreditinstitut" :rules="[rules.required]" required></v-text-field>
                          </v-flex>
                          <v-flex md4 :pa-2="!$vuetify.breakpoint.smAndDown">
                              <v-menu
                                      ref="menu"
                                      :close-on-content-click="false"
                                      v-model="menu"
                                      :nudge-right="40"
                                      :return-value.sync="birthdate"
                                      lazy
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      min-width="290px"
                              >
                                  <v-text-field
                                          box
                                          slot="activator"
                                          v-model="birthdateFormatted"
                                          label="Geburtsdatum"
                                          @blur="date = parseDate(birthdateFormatted)"
                                          :rules="[rules.required]"
                                  ></v-text-field>
                                  <v-date-picker
                                          ref="picker"
                                          :max="new Date().toISOString().substr(0, 10)"
                                          min="1920-01-01"
                                          v-model="birthdate"
                                          no-title scrollable
                                          locale="de-de"
                                          @change="$refs.menu.save(birthdate)">
                                  </v-date-picker>
                              </v-menu>
                          </v-flex>
                      </v-layout>
                      <h2>Angaben für den Vetrag</h2>
                      <v-layout row>
                          <v-flex  :pa-2="!$vuetify.breakpoint.smAndDown">
                              <h3>Ihre gewünschten Zusatzoptionen:</h3>
                                  <div v-if="$store.state.tvOption"><v-icon class="mr-2" style="vertical-align: bottom" color="green">fa-check</v-icon>Zusatzoption TV</div>
                                  <div v-if="$store.state.mobileOption"><v-icon class="mr-2" style="vertical-align: bottom" color="green">fa-check</v-icon>Zusatzoption Handy</div>
                                  <div v-if="!$store.state.tvOption && !$store.state.mobileOption"><v-icon class="mr-2" style="vertical-align: bottom">fas fa-times</v-icon>Keine</div>
                              <v-textarea v-model="message" box label="Ihre Nachricht an uns (optional)" class="mt-3"></v-textarea>
                          </v-flex>
                      </v-layout>
                      <v-layout row>
                          <v-spacer></v-spacer>
                          <v-btn color="#226894" dark @click="validate" :disabled="mailSent" :loading="buttonLoading" light>{{buttonText}}</v-btn>
                      </v-layout>
                  </v-form>
              </v-flex>
              <v-dialog
                      v-model="dialog"
                      max-width="400"
              >
                  <v-card>
                      <v-card-title class="headline">Vielen Dank für Ihre Anfrage!</v-card-title>

                      <v-card-text>
                          Wir melden uns so bald wie möglich bei Ihnen, um Ihr persönliches Angebot zu besprechen.
                      </v-card-text>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                                  color="green darken-1"
                                  flat="flat"
                                  @click="dialog = false"
                          >
                              Schließen
                          </v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
          </v-layout>
      </v-container>
  </div>
</template>

<script>
  import VTextarea from 'vuetify/lib/components/VTextarea/VTextarea'
  import VIcon from 'vuetify/lib/components/VIcon/VIcon'
  import VTextField from 'vuetify/lib/components/VTextField/VTextField'
  const IBAN = require('iban');

  export default {
    components: {
      VTextField,
      VTextarea, VIcon },
    data: () => ({
      buttonText: 'Absenden',
      buttonLoading: false,
      valid: false,
      menu: null,
      salutation: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      state: {text:'Deutschland', value: 'Deutschland'},
      idNumber: null,
      expiry: null,
      street: null,
      streetnr: null,
      zip: null,
      city: null,
      iban: null,
      bank: null,
      birthdate: null,
      birthdateFormatted: null,
      message: null,
      mailSent: false,
      dialog: false,
      states: [
        {text: 'Afghanistan', value: 'Afghanistan'},
        {text: 'Ägypten', value: 'Ägypten'},
        {text: 'Albanien', value: 'Albanien'},
        {text: 'Algerien', value: 'Algerien'},
        {text: 'Amerikanisch-Samoa', value: 'Amerikanisch-Samoa'},
        {text: 'Andorra', value: 'Andorra'},
        {text: 'Angola', value: 'Angola'},
        {text: 'Anguilla', value: 'Anguilla'},
        {text: 'Antarktis', value: 'Antarktis'},
        {text: 'Antigua und Barbuda', value: 'Antigua und Barbuda'},
        {text: 'Äquatorialguinea', value: 'Äquatorialguinea'},
        {text: 'Argentinien', value: 'Argentinien'},
        {text: 'Armenien', value: 'Armenien'},
        {text: 'Aruba', value: 'Aruba'},
        {text: 'Äthiopien', value: 'Äthiopien'},
        {text: 'Australien', value: 'Australien'},
        {text: 'Azerbaijan', value: 'Azerbaijan'},
        {text: 'Bahamas', value: 'Bahamas'},
        {text: 'Bahrain', value: 'Bahrain'},
        {text: 'Bangladesh', value: 'Bangladesh'},
        {text: 'Barbados', value: 'Barbados'},
        {text: 'Belgien', value: 'Belgien'},
        {text: 'Belize', value: 'Belize'},
        {text: 'Benin', value: 'Benin'},
        {text: 'Bermudas', value: 'Bermudas'},
        {text: 'Bhutan', value: 'Bhutan'},
        {text: 'Bolivien', value: 'Bolivien'},
        {text: 'Bosnien-Herzegovina', value: 'Bosnien-Herzegovina'},
        {text: 'Botswana', value: 'Botswana'},
        {text: 'Bouvet Island', value: 'Bouvet Island'},
        {text: 'Brasilien', value: 'Brasilien'},
        {text: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory'},
        {text: 'Brunei Darussalam', value: 'Brunei Darussalam'},
        {text: 'Bulgarien', value: 'Bulgarien'},
        {text: 'Burkina Faso', value: 'Burkina Faso'},
        {text: 'Burundi', value: 'Burundi'},
        {text: 'Canada', value: 'Canada'},
        {text: 'Chile', value: 'Chile'},
        {text: 'China', value: 'China'},
        {text: 'Christmas Island', value: 'Christmas Island'},
        {text: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands'},
        {text: 'Cook Islands', value: 'Cook Islands'},
        {text: 'Costa Rica', value: 'Costa Rica'},
        {text: 'Dänemark', value: 'Dänemark'},
        {text: 'Demokratische Republik Kongo', value: 'Demokratische Republik Kongo'},
        {text: 'Deutschland', value: 'Deutschland'},
        {text: 'Djibouti', value: 'Djibouti'},
        {text: 'Dominica', value: 'Dominica'},
        {text: 'Dominikanische Republik', value: 'Dominikanische Republik'},
        {text: 'Ecuador', value: 'Ecuador'},
        {text: 'El Salvador', value: 'El Salvador'},
        {text: 'Elfenbeinküste (Cote D\'Ivoire)', value: 'Elfenbeinküste (Cote D\'Ivoire)'},
        {text: 'Eritrea', value: 'Eritrea'},
        {text: 'Estland', value: 'Estland'},
        {text: 'Falkland-Inseln (Malvinas)', value: 'Falkland-Inseln (Malvinas)'},
        {text: 'Faröer-Inseln', value: 'Faröer-Inseln'},
        {text: 'Fiji', value: 'Fiji'},
        {text: 'Finnland', value: 'Finnland'},
        {text: 'France, Metropolitan', value: 'France, Metropolitan'},
        {text: 'Frankreich', value: 'Frankreich'},
        {text: 'Französisch Guiana', value: 'Französisch Guiana'},
        {text: 'Französisch Polynesien', value: 'Französisch Polynesien'},
        {text: 'Französisches Südl.Territorium', value: 'Französisches Südl.Territorium'},
        {text: 'Gabon', value: 'Gabon'},
        {text: 'Gambia', value: 'Gambia'},
        {text: 'Georgien', value: 'Georgien'},
        {text: 'Ghana', value: 'Ghana'},
        {text: 'Gibraltar', value: 'Gibraltar'},
        {text: 'Grenada', value: 'Grenada'},
        {text: 'Griechenland', value: 'Griechenland'},
        {text: 'Grönland', value: 'Grönland'},
        {text: 'Großbritannien', value: 'Großbritannien'},
        {text: 'Guadeloupe', value: 'Guadeloupe'},
        {text: 'Guam', value: 'Guam'},
        {text: 'Guatemala', value: 'Guatemala'},
        {text: 'Guinea', value: 'Guinea'},
        {text: 'Guinea-Bissau', value: 'Guinea-Bissau'},
        {text: 'Guyana', value: 'Guyana'},
        {text: 'Haiti', value: 'Haiti'},
        {text: 'Heard und Mc Donald Islands', value: 'Heard und Mc Donald Islands'},
        {text: 'Honduras', value: 'Honduras'},
        {text: 'Indien', value: 'Indien'},
        {text: 'Indonesien', value: 'Indonesien'},
        {text: 'Irak', value: 'Irak'},
        {text: 'Iran (Islamische Republik)', value: 'Iran (Islamische Republik)'},
        {text: 'Irland', value: 'Irland'},
        {text: 'Island', value: 'Island'},
        {text: 'Israel', value: 'Israel'},
        {text: 'Italien', value: 'Italien'},
        {text: 'Jamaica', value: 'Jamaica'},
        {text: 'Japan', value: 'Japan'},
        {text: 'Jemen', value: 'Jemen'},
        {text: 'Jordanien', value: 'Jordanien'},
        {text: 'Jugoslawien', value: 'Jugoslawien'},
        {text: 'Kamerun', value: 'Kamerun'},
        {text: 'Kap Verde', value: 'Kap Verde'},
        {text: 'Kasachstan', value: 'Kasachstan'},
        {text: 'Katar', value: 'Katar'},
        {text: 'Kayman Islands', value: 'Kayman Islands'},
        {text: 'Kenya', value: 'Kenya'},
        {text: 'Kirgisien', value: 'Kirgisien'},
        {text: 'Kiribati', value: 'Kiribati'},
        {text: 'Kolumbien', value: 'Kolumbien'},
        {text: 'Komoren', value: 'Komoren'},
        {text: 'Kong Hong', value: 'Kong Hong'},
        {text: 'Kongo', value: 'Kongo'},
        {text: 'Königreich Kambodscha', value: 'Königreich Kambodscha'},
        {text: 'Korea', value: 'Korea'},
        {text: 'Korea, Volksrepublik', value: 'Korea, Volksrepublik'},
        {text: 'Kuba', value: 'Kuba'},
        {text: 'Kuwait', value: 'Kuwait'},
        {text: 'Laos', value: 'Laos'},
        {text: 'Lesotho', value: 'Lesotho'},
        {text: 'Lettland', value: 'Lettland'},
        {text: 'Libanon', value: 'Libanon'},
        {text: 'Liberia', value: 'Liberia'},
        {text: 'Libyen', value: 'Libyen'},
        {text: 'Liechtenstein', value: 'Liechtenstein'},
        {text: 'Littauen', value: 'Littauen'},
        {text: 'Luxemburg', value: 'Luxemburg'},
        {text: 'Macao', value: 'Macao'},
        {text: 'Madagaskar', value: 'Madagaskar'},
        {text: 'Malawi', value: 'Malawi'},
        {text: 'Malaysien', value: 'Malaysien'},
        {text: 'Malediven', value: 'Malediven'},
        {text: 'Mali', value: 'Mali'},
        {text: 'Malta', value: 'Malta'},
        {text: 'Marokko', value: 'Marokko'},
        {text: 'Marshall-Inseln', value: 'Marshall-Inseln'},
        {text: 'Martinique', value: 'Martinique'},
        {text: 'Mauretanien', value: 'Mauretanien'},
        {text: 'Mauritius', value: 'Mauritius'},
        {text: 'Mayotte', value: 'Mayotte'},
        {text: 'Mazedonien, ehem. Jugoslawische Republik', value: 'Mazedonien, ehem. Jugoslawische Republik'},
        {text: 'Mexico', value: 'Mexico'},
        {text: 'Micronesien', value: 'Micronesien'},
        {text: 'Moldavien', value: 'Moldavien'},
        {text: 'Monaco', value: 'Monaco'},
        {text: 'Mongolei', value: 'Mongolei'},
        {text: 'Montserrat', value: 'Montserrat'},
        {text: 'Mozambique', value: 'Mozambique'},
        {text: 'Myanmar', value: 'Myanmar'},
        {text: 'Namibia', value: 'Namibia'},
        {text: 'Nauru', value: 'Nauru'},
        {text: 'Nepal', value: 'Nepal'},
        {text: 'Neu Kaledonien', value: 'Neu Kaledonien'},
        {text: 'Neuseeland', value: 'Neuseeland'},
        {text: 'Nicaragua', value: 'Nicaragua'},
        {text: 'Niederlande', value: 'Niederlande'},
        {text: 'Niederländische Antillen', value: 'Niederländische Antillen'},
        {text: 'Niger', value: 'Niger'},
        {text: 'Nigeria', value: 'Nigeria'},
        {text: 'Niue', value: 'Niue'},
        {text: 'Nördliche Marianneninseln', value: 'Nördliche Marianneninseln'},
        {text: 'Norfolk Island', value: 'Norfolk Island'},
        {text: 'Norwegen', value: 'Norwegen'},
        {text: 'Oman', value: 'Oman'},
        {text: 'Österreich (Austria)', value: 'Österreich (Austria)'},
        {text: 'Ost-Timor', value: 'Ost-Timor'},
        {text: 'Pakistan', value: 'Pakistan'},
        {text: 'Palau', value: 'Palau'},
        {text: 'Panama', value: 'Panama'},
        {text: 'Papua Neuguinea', value: 'Papua Neuguinea'},
        {text: 'Paraguay', value: 'Paraguay'},
        {text: 'Peru', value: 'Peru'},
        {text: 'Philippinen', value: 'Philippinen'},
        {text: 'Pitcairn', value: 'Pitcairn'},
        {text: 'Polen', value: 'Polen'},
        {text: 'Portugal', value: 'Portugal'},
        {text: 'Puerto Rico', value: 'Puerto Rico'},
        {text: 'Reunion', value: 'Reunion'},
        {text: 'Ruanda', value: 'Ruanda'},
        {text: 'Rumänien', value: 'Rumänien'},
        {text: 'Russische Föderation', value: 'Russische Föderation'},
        {text: 'Saint Kitts und Nevis', value: 'Saint Kitts und Nevis'},
        {text: 'Saint Lucia', value: 'Saint Lucia'},
        {text: 'Saint Vincent und Grenadines', value: 'Saint Vincent und Grenadines'},
        {text: 'Salomonen', value: 'Salomonen'},
        {text: 'Sambia', value: 'Sambia'},
        {text: 'Samoa', value: 'Samoa'},
        {text: 'San Marino', value: 'San Marino'},
        {text: 'Sao Tome und Principe', value: 'Sao Tome und Principe'},
        {text: 'Saudi Arabien', value: 'Saudi Arabien'},
        {text: 'Schweden', value: 'Schweden'},
        {text: 'Schweiz', value: 'Schweiz'},
        {text: 'Senegal', value: 'Senegal'},
        {text: 'Seychellen', value: 'Seychellen'},
        {text: 'Sierra Leone', value: 'Sierra Leone'},
        {text: 'Singapur', value: 'Singapur'},
        {text: 'Slovenien', value: 'Slovenien'},
        {text: 'Slowakei', value: 'Slowakei'},
        {text: 'Somalia', value: 'Somalia'},
        {text: 'Spanien', value: 'Spanien'},
        {text: 'Sri Lanka', value: 'Sri Lanka'},
        {text: 'St. Helena', value: 'St. Helena'},
        {text: 'St. Pierre und Miquelon', value: 'St. Pierre und Miquelon'},
        {text: 'Südafrika', value: 'Südafrika'},
        {text: 'Sudan', value: 'Sudan'},
        {text: 'Südgeorgien und Südliche Sandwich-Inseln', value: 'Südgeorgien und Südliche Sandwich-Inseln'},
        {text: 'Surinam', value: 'Surinam'},
        {text: 'Svalbard und Jan Mayen Islands', value: 'Svalbard und Jan Mayen Islands'},
        {text: 'Swaziland', value: 'Swaziland'},
        {text: 'Syrien, Arabische Republik', value: 'Syrien, Arabische Republik'},
        {text: 'Tadschikistan', value: 'Tadschikistan'},
        {text: 'Taiwan', value: 'Taiwan'},
        {text: 'Tansania, United Republic of', value: 'Tansania, United Republic of'},
        {text: 'Thailand', value: 'Thailand'},
        {text: 'Togo', value: 'Togo'},
        {text: 'Tokelau', value: 'Tokelau'},
        {text: 'Tonga', value: 'Tonga'},
        {text: 'Trinidad und Tobago', value: 'Trinidad und Tobago'},
        {text: 'Tschad', value: 'Tschad'},
        {text: 'Tschechische Republik', value: 'Tschechische Republik'},
        {text: 'Tschechoslowakei (ehemalige)', value: 'Tschechoslowakei (ehemalige)'},
        {text: 'Tunesien', value: 'Tunesien'},
        {text: 'Turk und Caicos-Inseln', value: 'Turk und Caicos-Inseln'},
        {text: 'Türkei', value: 'Türkei'},
        {text: 'Turkmenistan', value: 'Turkmenistan'},
        {text: 'Tuvalu', value: 'Tuvalu'},
        {text: 'Uganda', value: 'Uganda'},
        {text: 'Ukraine', value: 'Ukraine'},
        {text: 'Ungarn', value: 'Ungarn'},
        {text: 'Uruguay', value: 'Uruguay'},
        {text: 'Usbekistan', value: 'Usbekistan'},
        {text: 'Vanuatu', value: 'Vanuatu'},
        {text: 'Vatikanstaat', value: 'Vatikanstaat'},
        {text: 'Venezuela', value: 'Venezuela'},
        {text: 'Vereinigte Arabische Emirate', value: 'Vereinigte Arabische Emirate'},
        {text: 'Vereinigte Staaten', value: 'Vereinigte Staaten'},
        {text: 'Vereinigte Staaten, Minor Outlying Islands', value: 'Vereinigte Staaten, Minor Outlying Islands'},
        {text: 'Vietnam', value: 'Vietnam'},
        {text: 'Virgin Islands (Britisch)', value: 'Virgin Islands (Britisch)'},
        {text: 'Virgin Islands (U.S.)', value: 'Virgin Islands (U.S.)'},
        {text: 'Wallis und Futuna Islands', value: 'Wallis und Futuna Islands'},
        {text: 'Weißrußland (Belarus)', value: 'Weißrußland (Belarus)'},
        {text: 'Westsahara', value: 'Westsahara'},
        {text: 'Zentralafrikanische Republik', value: 'Zentralafrikanische Republik'},
        {text: 'Zimbabwe', value: 'Zimbabwe'},
        {text: 'Zypern', value: 'Zypern'},
      ],
      rules: {
        required: (v) => !!v || 'Bitte füllen Sie dieses Feld aus',
        IBAN: (v) => IBAN.isValid(v) || 'Bitte geben sie eine gültige IBAN ein',
        email: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Bitte geben sie eine gültige Email-Adresse ein', // eslint-disable-line
        phone: (v) => /^[0-9-+\s()]*$/.test(v) || 'Bitte geben sie eine gültige Telefonnummer ein',
        idNumber: (v) => /^([0-9CFGHJKLMNPRTVWXYZ]{9}|[0-9CFGHJKLMNPRTVWXYZ]{10})$/.test(v) || 'Bitte geben sie eine gültige deutsche Ausweisnummer ein'
      }
    }),
    watch: {
      menu (val) {
        val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
      birthdate () {
        this.birthdateFormatted = this.formatDate(this.birthdate)
      }
    },
    mounted() {
      const plugin = document.createElement("script");
      plugin.setAttribute(
        "src",
        "https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js"
      );
      plugin.async = true;
      document.head.appendChild(plugin);
      this.$vuetify.goTo(0)
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [ year, month, day ] = date.split('-')
        return `${day}.${month}.${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('.')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.sendMail()
        }
      },
      resetData() {
        // this.salutation = null
        // this.firstname = null
        // this.lastname = null
        // this.birthdateFormatted = null
        // this.email = null
        // this.phone = null
        // this.street = null
        // this.streetnr = null
        // this.zip = null
        // this.state = {text:'Deutschland', value: 'Deutschland'}
        // this.idNumber = null
        // this.expiry = null
        // this.city = null
        // this.iban = null
        // this.bank = null
        // this.message = null
        // this.$validator.reset()
        this.$refs.form.reset()
      },
      sendMail() {
        this.buttonLoading = true
        let none = !this.$store.state.tvOption && !this.$store.state.mobileOption

        let params = {
              salutation: this.salutation,
              firstname: this.firstname,
              lastname: this.lastname,
              birthdate: this.birthdateFormatted,
              email: this.email,
              tel: this.phone,
              street: this.street,
              streetnr: this.streetnr,
              zip: this.zip,
              mobileInfos: this.$store.state.mobileOption ? 'Staatsangehörigkeit: ' + this.state.text + ', Ausweisnummer: ' + this.idNumber + ', gültig bis ' + this.expiry : '',
              city: this.city,
              iban: this.iban,
              bank: this.bank,
              tvOption: this.$store.state.tvOption,
              mobileOption: this.$store.state.mobileOption,
              message: this.message ? this.message : 'Keine',
              options: `Gewählte Zusatzoptionen:\n ${this.$store.state.tvOption ? 'TV-Option\n' : '' }${this.$store.state.mobileOption ? 'Handy-Option\n' : '' } ${none ? 'Keine\n' : ''}`
          }
          emailjs.send('service_yxvntf8', 'template_easyphones', params, 'tAjTZEArjU-nFgYpg')  // eslint-disable-line
      .then(() => {
        gtag_report_conversion() // eslint-disable-line
        this.mailSent = true
        this.dialog = true
        // this.resetData()
        this.buttonLoading = false
        this.buttonText = 'Gesendet!'
      })
        .catch((e) => {
          console.log(e)
          this.buttonLoading = false
        })
      }
    },
  }
</script>

<style lang="scss">
    .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
        background-color: gray !important;
    }

    .v-messages__message {
        line-height: 1.6;
    }

</style>